/* istanbul ignore file */
import { getGuid } from './get-guid';
/**
 * 生成 v4 版本的 uuid
 * @returns uuid 字符串
 */
export function uuidv4() {
    // eslint-disable-next-line
    return getGuid();
}
